import React, { useState } from 'react';
import './Contact.css';
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPills } from '@fortawesome/free-solid-svg-icons';
import { Navigate, useNavigate } from 'react-router-dom';

const Contact = () => {
  const [formData, setFormData] = useState({ email: '', message: '' });
  const [success, setSuccess] = useState('');

  const SERVICE_ID = 'service_ma9nr3c';
  const TEMPLATE_ID = 'template_qgvlztn';
  const PUBLIC_KEY = 'DlJwdfxB90oWSDIq4';


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

  emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
    .then(() => {
      setSuccess('Thank you for reaching out! Your message has been sent.');
      setFormData({ email: '', message: '' });
    })
    .catch((error) => {
      console.error('Email sending failed:', error);
      setSuccess('Something went wrong. Please try again later.');
    });
  };

  return (
    <div className="contact-background">
      <div className="contact-container">
        <h2 className="contact-title">Get in Touch </h2>

        <div className="contact-content">
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit" className="contact-button">Send Message</button>
            {success && <p className="success-message">{success}</p>}
          </form>

          <div className="contact-info">
            <h3>Contact Info</h3>
            <p><strong>📞 Phone:</strong> +91 91820 37460</p>
            <p><strong>📩 Email:</strong> info@osiqsolutions.com</p>
            <p><strong>📍 Address:</strong> OSIQ SOLUTIONS, Hyderabad, India</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
